import { FC } from 'react';
import classNames from 'classnames';

import { ViewMode } from '@rikstv/play-player/src/player.types';
import { H1, H2, Meta } from '@rikstv/shared-components';

import { MicroData } from '../../forces/utils/microdata.type';
import { ProviderImage } from '../providerImage/ProviderImage';

import { AppStoreNotificationBanner } from './AppStoreNotificationBanner';
import { isTheatreMode } from './coverPage.utils';

import './CoverPageHero.scss';

interface Props {
  microdata: MicroData;
  title: string | string[];
  episodeTitle?: string;
  programPointsComponent?: JSX.Element;
  descriptionComponent?: JSX.Element;
  wishlistButton?: JSX.Element;
  image?: string;
  providerImageUrl?: string;
  metadataComponent?: JSX.Element;
  playerComponent?: JSX.Element;
  viewMode: ViewMode;
}

export const CoverPageHero: FC<Props> = ({
  title,
  episodeTitle,
  metadataComponent,
  descriptionComponent,
  programPointsComponent,
  microdata,
  image,
  providerImageUrl,
  playerComponent,
  viewMode,
  wishlistButton,
}) => {
  const sectionStyle = {
    backgroundImage: `url(${image})`,
  };

  const isInTheatreMode = isTheatreMode(viewMode);

  return (
    <div className="coverpage-hero" style={sectionStyle}>
      <AppStoreNotificationBanner />
      <div className="coverpage-hero-overlay" />
      <div
        className={classNames('coverpage-hero-grid', {
          'coverpage-hero-grid__theatre-mode': isInTheatreMode,
        })}>
        <div
          className={classNames('coverpage-hero-grid-player', {
            'coverpage-hero-grid-player__theatre-mode': isInTheatreMode,
          })}>
          {providerImageUrl && !isInTheatreMode && (
            <ProviderImage size="large" src={providerImageUrl} className="coverpage-hero-grid-player__logo" />
          )}
          <div className="playback">{playerComponent}</div>
        </div>
        {isInTheatreMode && <div className="coverpage-hero-grid-programpoints">{programPointsComponent}</div>}
        <div className="coverpage-hero-grid-information">
          <div className="coverpage-hero-grid-information-text">
            <H1 className="coverpage-hero-grid-information-text-title" itemProp="name">
              {title}
            </H1>
            {metadataComponent && (
              <Meta
                className="coverpage-hero-grid-information-text-subtitle"
                itemProp={microdata.itemPropType === 'channel' ? 'name' : ''}>
                {metadataComponent}
              </Meta>
            )}
            {episodeTitle && (
              <H2 className="coverpage-hero-grid-information-text-episodetitle" lookLike="title-4">
                {episodeTitle}
              </H2>
            )}
            {descriptionComponent}
          </div>
          {wishlistButton}
        </div>
      </div>
    </div>
  );
};
